import { render } from "./ClinicOverlay.vue?vue&type=template&id=c437516a&scoped=true&lang=pug"
import script from "./ClinicOverlay.vue?vue&type=script&lang=js"
export * from "./ClinicOverlay.vue?vue&type=script&lang=js"

import "./ClinicOverlay.vue?vue&type=style&index=0&id=c437516a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c437516a"]])

export default __exports__